module.exports = "<input ng-model=$ctrl.value ng-change=$ctrl.onInputChange() class=gmc-form-control type={{$ctrl.inputType}} placeholder={{::$ctrl.placeholder}} ng-attr-id={{::$ctrl.labelId}}> <span class=icon ng-show=!!$ctrl.value ng-click=$ctrl.toggleInputType()><i class=material-icons>{{$ctrl.icon}}</i></span>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-password-input/gmc-password-input.component.html
// module id = 526
// module chunks = 31